import axios from 'axios';
import jwt_decode from 'jwt-decode';
import { LOCAL_STORAGE_KEYS } from '@/constants';
import { ImpersonateToken, UserToken } from '@/models';

export const hasToken = (): boolean => {
  const user = localStorage.getItem(LOCAL_STORAGE_KEYS.USER);
  return !!user && user !== '';
};

export const getToken = (): string => {
  const user = localStorage.getItem(LOCAL_STORAGE_KEYS.USER);
  return user ? JSON.parse(user).token : '';
};

export const isImpersonating = (): boolean => {
  const user = localStorage.getItem(LOCAL_STORAGE_KEYS.USER);
  return user && JSON.parse(user).impersonate;
};

export const setToken = (token: string): void => {
  localStorage.setItem(LOCAL_STORAGE_KEYS.USER, JSON.stringify({ token: token, impersonate: true }));
};

export const clearToken = (): void => {
  localStorage.clear();
};

export const exchangeToken = async (authCode: string): Promise<string> => {
  try {
    const response = await axios.post('/api/auth/oauth2callback', {
      code: authCode
    });
    const token = response.data.access_token;
    if (response.status === 200) {
      localStorage.setItem(LOCAL_STORAGE_KEYS.USER, JSON.stringify({ token: token }));
      return token;
    }
    return '';
  } catch (e) {
    return '';
  }
};

export const login = async (token: string): Promise<boolean> => {
  try {
    axios.defaults.headers.common = { Authorization: `Bearer ${token}` };
    const response = await axios.post('/api/auth/login', {});
    if (response.status === 200) {
      localStorage.setItem(LOCAL_STORAGE_KEYS.USER, JSON.stringify({ token: token }));
      return true;
    }
    return false;
  } catch (e) {
    return false;
  }
};

const getTokenFromMasterToken = (masterToken: string) => {
  return masterToken.split(' ')[1];
};

export const getTokenForExternalApp = (): string => {
  const user = localStorage.getItem(LOCAL_STORAGE_KEYS.USER);
  let result = '';
  if (user) {
    const { token = '' } = JSON.parse(user) as UserToken;
    result = token;
    if (isImpersonating()) {
      const { masterToken = '' } = jwt_decode(token) as ImpersonateToken;
      result = getTokenFromMasterToken(masterToken);
    }
  }
  return result;
};
